{
  "people": "People",
  "loadingPeople": "Loading people…",
  "loadingTeams": "Loading teams…",
  "loadingReferrals": "Loading referrals…",
  "teams": "Teams",
  "filters": "Filters",
  "more": "More",
  "search": "Search People",
  "noManager": "No Manager",
  "moreRoles": "+{{count}} More",
  "allRoles": "All sales roles",
  "practiceLink": "Practice Link",
  "closeNote": "Close Details",
  "history": "Reporting history",
  "documentFollowUp": "Document Follow-Up",
  "viewProfile": "View profile",
  "removeFilter": "Remove Filter: {{label}}"
}
